export const dashboardRoutes = {
  getData: '/api/v1/dashboard',
}
